// RiskCard.tsx
import { RiskItem } from '../types';

const levelConfig = {
  high: { bg: 'bg-red-50 border-red-200', badge: 'bg-red-600', label: '高风险' },
  medium: { bg: 'bg-yellow-50 border-yellow-200', badge: 'bg-yellow-600', label: '中风险' },
  low: { bg: 'bg-green-50 border-green-200', badge: 'bg-green-600', label: '低风险' },
};

export default function RiskCard({ risk, index }: { risk: RiskItem; index: number }) {
  const config = levelConfig[risk.risk_level];

  return (
    <div className={`border rounded-lg p-5 mb-4 ${config.bg}`}>
      <div className="flex items-center gap-2 mb-3">
        <span className={`text-white text-xs px-2 py-0.5 rounded ${config.badge}`}>
          {config.label}
        </span>
        <span className="text-sm text-gray-500">风险 #{index + 1}</span>
      </div>

      <div className="space-y-3">
        <div>
          <div className="text-sm font-medium text-gray-700 mb-1">📌 原文条款</div>
          <div className="text-sm text-gray-600 bg-white bg-opacity-50 rounded p-3 font-mono">
            {risk.clause_text}
          </div>
        </div>

        <div>
          <div className="text-sm font-medium text-gray-700 mb-1">⚠️ 风险描述</div>
          <div className="text-sm text-gray-600">{risk.risk_description}</div>
        </div>

        <div>
          <div className="text-sm font-medium text-gray-700 mb-1">💡 修改建议</div>
          <div className="text-sm text-gray-600">{risk.suggestion}</div>
        </div>

        {risk.legal_basis && (
          <div>
            <div className="text-sm font-medium text-gray-700 mb-1">⚖️ 法律依据</div>
            <div className="text-sm text-gray-500">{risk.legal_basis}</div>
          </div>
        )}
      </div>
    </div>
  );
}